import {
  ICreateLegalEntityParams,
  ILegalEntity,
  IWaiveLegalEntityDocumentParams,
} from '@common/interfaces/legalEntity'
import Base from './base'

export default class LegalEntities extends Base {
  list(clientId: string) {
    return this.apiClient.get('legal-entities', { clientId })
  }

  create(data: ICreateLegalEntityParams) {
    return this.apiClient.post('legal-entities', data)
  }

  update(id: string, data: Partial<Pick<ILegalEntity, 'entityName' | 'incState' | 'hqState'>>) {
    return this.apiClient.put(`legal-entities/${id}`, data)
  }

  delete(id: string) {
    return this.apiClient.delete(`legal-entities/${id}`)
  }

  waive(id: string, data: { waived: boolean; waivedNote?: string }) {
    return this.apiClient.put(`legal-entities/${id}/waive`, data)
  }

  waiveDocument(id: string, data: IWaiveLegalEntityDocumentParams) {
    return this.apiClient.post(`legal-entities/${id}/document-waivers`, data)
  }

  unwaiveDocument(id: string, waiverId: string) {
    return this.apiClient.delete(`legal-entities/${id}/document-waivers/${waiverId}`)
  }
}
